import request from '@/shared/api/request';

export const updateBucketCors = (
  { name, origin }: { name: string; origin: string },
  data: {
    allowed_origin: string;
    allowed_method: string[];
    allowed_header: string[];
    max_age_seconds: number;
  },
): Promise<unknown> =>
  request({
    url: `/buckets/${name}/cors/${origin}/`,
    method: 'PUT',
    data,
  });
